import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()
  const settings = useQuery(api.siteSettings.get)

  const email = settings?.contactEmail ?? 'admin@omnitax.ca'
  const phone = settings?.contactPhone ?? '403-369-3711'
  const cell = settings?.contactCell ?? '403-700-1368'
  const address = settings?.address ?? 'B7, 260300 Writing Creek Cres\nRockyview County, AB, T4A-0XB'

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/images/omnitax.png" alt="Omni Accounting & Tax Logo" className="footer-logo" />
            <h3>Omni Accounting & Tax</h3>
            <p>Professional tax consulting and accounting services for businesses and individuals.</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>Email: <a href={`mailto:${email}`}>{email}</a></p>
            <p>Phone: <a href={`tel:${phone}`}>{phone}</a></p>
            <p>Cell: <a href={`tel:${cell}`}>{cell}</a></p>
          </div>

          <div className="footer-section">
            <h4>Address</h4>
            <p>{address.split('\n').map((line, i) => (
              <span key={i}>{line}{i < address.split('\n').length - 1 && <br/>}</span>
            ))}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Omni Accounting & Tax. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
